import React, { Fragment,  } from 'react';

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

'use strict';

function RundedrehenMapItemsListSkeletonRow({image, width}) {

  return <div className="
    map-list-item-skeleton
    py-0.5 md:py-1
    px-3 md:px-4
  ">
    <div className="
      flex items-start
      space-x-4
      overflow-hidden
      grow
      map-list-item-inner
    ">
      {image && <div className="
        w-10 h-10 md:w-11 md:h-11
        flex-grow-0 flex-shrink-0
      ">
        <Skeleton width="100%" height="100%"></Skeleton>
      </div>}

      <div className="
        min-w-0 grow
        relative
      ">
        <Skeleton height="20px" width={width}></Skeleton>
        {image && <Skeleton height="14px" width="75%" inline={false}></Skeleton>}
      </div>
    </div>
  </div>
}

export default RundedrehenMapItemsListSkeletonRow;
